/**
 * Odmiana rzeczownika przez liczebnik.
 *
 * Polski ma trzy formy tam, gdzie angielski ma dwie, więc „Wystawiono 4 umów"
 * wychodzi samo z każdego szablonu pisanego pod angielską liczbę mnogą.
 * W systemie, który odmienia kwoty słownie na umowach, taki komunikat
 * w panelu razi tym bardziej.
 *
 *   odmien(1, "umowa", "umowy", "umów")  → "umowa"
 *   odmien(4, …)                          → "umowy"
 *   odmien(5, …), odmien(12, …), odmien(22, …) → "umów", "umów", "umowy"
 */
export function odmien(ile: number, jedna: string, kilka: string, wiele: string): string {
  const n = Math.abs(ile);
  if (n === 1) return jedna;
  const dziesiatki = n % 100;
  // Nastolatki idą z formą dopełniaczową mimo końcówki 2–4: „dwanaście umów".
  if (dziesiatki >= 12 && dziesiatki <= 14) return wiele;
  const jednosci = n % 10;
  return jednosci >= 2 && jednosci <= 4 ? kilka : wiele;
}

/** Liczba z odmienionym rzeczownikiem: „4 umowy".
 *
 * Formy podaje się w mianowniku liczby pojedynczej, mnogiej i w dopełniaczu.
 * Przy zdaniu wymagającym innego przypadka („zebrano 3 z 5 umów") wszystkie
 * trzy formy bywają takie same — i wtedy też trzeba je podać, zamiast liczyć,
 * że jedna wystarczy.
 */
export function ile(n: number, jedna: string, kilka: string, wiele: string): string {
  return `${n} ${odmien(n, jedna, kilka, wiele)}`;
}
